import React__default from 'react';
import { F as Form } from '../internalComponents/Form/Form-BQnr15NK.js';

const FeedbackFormState = ({
  children,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(Form, restProps, children);

export { FeedbackFormState as F };
//# sourceMappingURL=FeedbackFormState-Bn3lk58_.js.map
